import App from './App'
import router from './router'
import "./assets/css/common.css"
import BaiduMap from 'vue-baidu-map'
import { goAnchor, GetQueryString } from './common/js/utils';
Vue.prototype.$goAnchor=goAnchor;
Vue.prototype.$GetQueryString=GetQueryString;
Vue.use(BaiduMap, {
  ak: 'Az0Y7f3dRyXbSPqplZDVGT2Db9pOYaPV&callback'
})
Vue.config.productionTip = false
router.afterEach(() => {
  window.scrollTo(0,0);
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js